import { Navigate, useParams } from 'react-router-dom'

export default function LegacyGenerationTaskRedirect() {
  const { genId } = useParams()
  const suffix = genId ? `&gen_id=${encodeURIComponent(genId)}` : ''
  return <Navigate to={`/profile?tab=history${suffix}`} replace />
}
